const obj = {
  server: {
    api: "https://api-dev.warriortrading.com/api",
    stock: "https://scan-dev.warriortrading.com",
    identity: "https://identity-dev.warriortrading.com/security",
    chatroom: "https://chatroom-dev.warriortrading.com",
    sim: "https://sim-dev.warriortrading.com",
  },
  scannerServers: [
    {
      name: "scan-dev",
      value: "https://scan-dev.warriortrading.com",
      down: "",
      up: "",
    },
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
  ],
};

export default obj;
